import React, { useState, useEffect, useMemo, useCallback, memo } from 'react';
import EmptySection from 'components/lib/EmptySection';
import Accordion from 'components/lib/Accordion';
import Carousel from 'components/lib/Carousel';
import FlipCard from 'components/lib/FlipCard';
import FullPageText from 'components/lib/FullPageText';
import Multichoice from 'components/lib/Multichoice';
import Sortation from 'components/lib/Sortation';
import Matching from 'components/lib/Matching';
import TextAndImage from 'components/lib/TextAndImage';
import HotSpot from 'components/lib/HotSpot';
import FiveStarRating from 'components/lib/FiveStarRating';
import ResultsPage from 'components/lib/ResultsPage';
import ClickAndReveal from 'components/lib/ClickAndReveal';
import ContentCards from 'components/lib/ContentCard';
import SelectOptions from 'components/lib/SelectOptions';
import TopicPortal from 'components/lib/TopicPortal';
import Assessment from '../lib/Assessment';
import AssessmentIntroduction from '../lib/AssessmentIntroduction';
import AssessmentQuestion from '../lib/AssessmentQuestion';
import AssessmentResults from '../lib/AssessmentResults';
import { Block } from '@chameleoncreator/creator-app';

const InteractionComponents = {
  Accordion,
  Carousel,
  FlipCard,
  FullPageText,
  Multichoice,
  Sortation,
  Matching,
  TextAndImage,
  HotSpot,
  FiveStarRating,
  ResultsPage,
  ClickAndReveal,
  SelectOptions,
  TopicPortal,
  Assessment,
  AssessmentIntroduction,
  AssessmentQuestion,
  AssessmentResults,
  ContentCards,
};

interface IInteractions_EditorProps {
  currentTopicId?: string | number;
  currentInteractionId: string | number | undefined;
  interactions: Block[];
}

const Interactions_Editor = ({
  currentTopicId,
  currentInteractionId,
  interactions,
}: IInteractions_EditorProps) => {
  if (!interactions.length) {
    return <EmptySection />;
  }

  const interaction = interactions.find(
    (i: any) => i.id === (currentInteractionId || interactions[0].id)
  ) as any;

  if (!interaction) {
    return null;
  }

  const Interaction = InteractionComponents[interaction?.meta?.subType];

  return (
    <Interaction
      key={interaction.id}
      blockId={interaction.id}
      isOpen={true}
      aria-label={`Interaction: ${interaction?.props?.name}`}
      data={{
        ...interaction,
      }}
    />
  );
};

export default Interactions_Editor;
